export default [
    {
        path: '/family-sites',
        name: 'family-sites',
        component: () => import('../../pages/familySites/IndexPage.vue'),
        meta: {
            title: 'Family Sites',
            requiresAuth: true,
        },
    },
]
